import React from 'react';
import { Card } from '@mui/material';
import { makeStyles } from '~/tools/makeStyles';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import classNames from 'classnames';

const useStyles = makeStyles(() => ({
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    maxWidth: 378,
    '&:hover': {
      transition: 'all 0.2s ease-out',
      boxShadow: '0px 8px 12px rgba(38, 38, 38, 0.2);',
      top: -4,
      cursor: 'pointer',
    },
    background: '#FFFFFF',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.25)',
    borderRadius: 4,
  },
  headerContainer: {
    padding: 24,
  },
  mainContainer: {
    padding: 24,
  },
  cardLink: {
    background: '#EFFAFC',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '16px 0',
    borderTop: '1px solid #E0E0E0',
  },
  linkText: {
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: 14,
    margin: 0,
  },
  linkIcon: {
    width: 16,
    height: 16,
    marginLeft: 8,
  },
  clickabledLink: {
    color: '#0F7B85',
    fill: '#0F7B85',
    cursor: 'pointer',
  },
  unclickabledLink: {
    color: '#bdbdbd',
    fill: '#bdbdbd',
    cursor: 'default',
  },
}));

function CardContainer({ children, onClick, onMouseEnter, onMouseLeave, translation, showLinkArea, renderHeader }) {
  const classes = useStyles();
  return (
    <Card className={classes.cardContainer} onClick={onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
      {renderHeader && <div className={classes.headerContainer}>{renderHeader()}</div>}
      <div>
        <div className={classes.mainContainer}>{children}</div>
        {(onClick || showLinkArea) && (
          <div className={classes.cardLink}>
            <p
              className={classNames(classes.linkText, {
                [classes.clickabledLink]: onClick,
                [classes.unclickabledLink]: !onClick,
              })}
            >
              {translation.moreDetails}
            </p>
            <ArrowRightAltIcon
              className={classNames(classes.linkIcon, {
                [classes.clickabledLink]: onClick,
                [classes.unclickabledLink]: !onClick,
              })}
            />
          </div>
        )}
      </div>
    </Card>
  );
}

export default CardContainer;
